export const validationsEn = {
  required: 'This field is required',
  email: 'This field must be a valid email',
  min_value: 'The minimum value for this field is {min}',
  max_value: 'The maximum value for this field is {max}',
  ip:'This not show like IP',
  host:'This not show like url',
  phone: 'This field must be a valid phone',
  numeric: 'This field must be a valid integer number',
  float: {
    hint: 'For example: 12.3',
    hint_min: 'The minimum value is {min}.',
    hint_max: 'The maximun value is {max}.',
    hint_decimals: 'The maximun decimal numbers is {decimals}.',
  },
  categoryPercentage:'The sum of the levels percentage is not 100, ensure the sum of the levels percentage result in 100'
};